import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedstate from 'vuex-persistedstate'
import {commonApi} from '@/api/common'
Vue.use(Vuex)

const state = {
    isLogin: false, //用户是否登录
    isCollapse: false, //侧边导航是否折叠
    isFreshToken:false,//是否已经刷新过token
    showLoginDialog:false,
    platformName: 'aliance', //平台名称，用于单点登录
    userInfo: {
        userName: '',
        userId: '',
        token:null,
        refreshToken:null,
        expire:0,
    },
    //权限相关数据
	permissionInfo: {
		backEndId: EpetJs.Const.ENV == "dev" ? 16 : 9,//后台id
		isManager: null,// 是否是超管
		sidebarList: [],//侧边栏菜单列表
		permissionList: [],//所有权限列表，带层级关系
		btnList: [],//按钮权限列表
		myShopTypeList: [], // 当前用户有权限的核算主体列表
		selectedShopType: '',//选中的核算主体类型
	},
    themeColor: '#282e38',
    contentBackground: '',
    activeItem: {},
    fields: [],
    navList: [], //菜单列表数据
}

const mutations = {
    changeLoginState(state, data) {
        state.isLogin = data.isLogin
    },
    loginout(state) {
		state.isLogin = false
		state.userInfo.userName = ''
		state.userInfo.userId = ''
		state.userInfo.token = null
	},
    setActiveItem(state, data) {
        state.activeItem = data;
    },
    setFields(state, data) {
        state.fields = data;
    },
    changeNavView(state, isCollapse) {
        state.isCollapse = isCollapse
    },
    saveUser(state, data) {
        state.userInfo.userName = data.userName;
        state.userInfo.userId   = data.userId
    },
    saveToken(state, data) {
        state.userInfo.token = data.token;
        state.userInfo.refreshToken = data.refreshToken;
        state.userInfo.expire = data.expire
    },
    changeFreshToken(satte,data){
        state.isFreshToken = data.isFreshToken
    },
    setContentBackground(state, data) {
        state.contentBackground = data
    },
    setNavList: (state, data) => {
        state.navList = data
    },
    changeLoginDialog:(state, data)=>{
        state.showLoginDialog = data
    },
    // 保存菜单栏
	changeSidebarList(state, data) {
		state.permissionInfo.sidebarList = data
	},
    // 权限相关
    // 保存超管
    changeManager(state, data) {
		state.permissionInfo.isManager = data
	},
    // 权限写入本地，扁平化
	savePermissionList(state, data) {
		state.permissionInfo.permissionList = data
	},
	// 保存按钮权限
	savePermissionBtnList(state, data) {
		state.permissionInfo.btnList = data
	},
}
const actions = {
    // 获取该用户的菜单列表
    getNavList({commit}) {
        return new Promise((resolve) => {
            commit("setNavList", res)
            resolve(res)
        })
    },
    getRoles({commit,state},userInfo) {
        return new Promise((resolve, reject) => {
            EpetJs.Common.ajax('post',commonApi.commonLogin,userInfo).then((res) => {
                resolve(res.data)
            })
        }).catch(error => {
            reject(error);
        })
    },
    //重新获取token
    getToken({commit,state}){
        return new Promise((resolve, reject) => {
            EpetJs.Common.get(commonApi.commonAuth,userInfo).then((res) => {
                commit('saveToken', {token:res.data.token,refreshToken:res.data.refresh_token})
                resolve(res.data)
            })
        }).catch(error => {
            reject(error);
        })
    },
    //获取按钮权限
	getBtns({ commit, state, dispatch },front_id) {
		EpetJs.Common.ajax('get', `${commonApi.getBtn}/${state.permissionInfo.backEndId}/${front_id}`).then(res => {
			if (res) {
				let tempBtn = JSON.parse(JSON.stringify(state.permissionInfo.btnList))
				res.data.data.map(v => {
					if (state.permissionInfo.btnList.some(b => {
						return b == v.component_name
					})) {
						return
					}
					tempBtn.push(v.component_name)
				})
				commit('savePermissionBtnList', tempBtn)
				//保存权限列表
				dispatch('saveLocalPermissionList',res.data.data)
			}
		})
	},
	//更新保存本地权限列表
	saveLocalPermissionList({commit,state},data) {
		let temp = state.permissionInfo.permissionList
		data.map(v => {
			if (state.permissionInfo.permissionList.includes(v)) {
				return
			}
			temp.push(v)
		})
		commit('savePermissionList', temp)
	},
}
const store = new Vuex.Store({
    state,
    mutations,
    actions,
    plugins: [createPersistedstate({ storage: window.sessionStorage })]
})
export default store
